(() => {
  const SOURCE_LABEL = 'Kilde-URL:';
  const SOURCE_FIELD_SELECTOR = '[id="lead#source_url"]';
  const observedRoots = new WeakSet();

  const currentUrl = () => window.location.href;

  const urlForCustomerTag = () => currentUrl().replaceAll(',', '%2C');

  const setControlledValue = (field, value) => {
    const prototype = field instanceof HTMLTextAreaElement
      ? HTMLTextAreaElement.prototype
      : HTMLInputElement.prototype;
    const valueSetter = Object.getOwnPropertyDescriptor(prototype, 'value')?.set;

    if (valueSetter) {
      valueSetter.call(field, value);
    } else {
      field.value = value;
    }

    field.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
    field.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
  };

  const fillNativeFields = (scope) => {
    if (!scope || typeof scope.querySelectorAll !== 'function') return;

    scope.querySelectorAll('[data-lead-source-url]').forEach((field) => {
      field.value = currentUrl();
    });

    scope.querySelectorAll('[data-lead-source-tags]').forEach((field) => {
      const baseTags = field.dataset.leadSourceBaseTags || '';
      field.value = [baseTags, `${SOURCE_LABEL} ${urlForCustomerTag()}`]
        .filter(Boolean)
        .join(',');
    });
  };

  const prepareShopifyFormsSourceField = (form) => {
    const sourceField = form.querySelector(SOURCE_FIELD_SELECTOR);
    if (!sourceField) return null;

    sourceField.tabIndex = -1;
    sourceField.setAttribute('aria-hidden', 'true');
    const fieldContainer = sourceField.closest('[class*="_formFieldContainer_"]');
    if (fieldContainer) fieldContainer.hidden = true;
    if (sourceField.value !== currentUrl()) {
      setControlledValue(sourceField, currentUrl());
    }

    return sourceField;
  };

  const writeShopifyFormsSource = (form) => {
    if (!(form instanceof HTMLFormElement)) return;

    const sourceField = prepareShopifyFormsSourceField(form);
    if (sourceField) {
      setControlledValue(sourceField, currentUrl());
      return;
    }

    const message = form.querySelector('textarea[name="custom#besked"]');
    if (!message) return;

    const sourceLine = `${SOURCE_LABEL} ${currentUrl()}`;
    const previousValue = message.value
      .replace(/\n{2}Kilde-URL:\s*https?:\/\/[^\n]*\s*$/i, '')
      .trimEnd();
    const nextValue = `${previousValue}\n\n${sourceLine}`;

    if (message.value !== nextValue) {
      setControlledValue(message, nextValue);
    }
  };

  const enhanceShopifyForms = () => {
    document.querySelectorAll('shopify-forms-embed').forEach((host) => {
      const root = host.shadowRoot;
      if (!root) return;

      if (!root.getElementById('LeadSourceUrlFieldStyles')) {
        const style = document.createElement('style');
        style.id = 'LeadSourceUrlFieldStyles';
        style.textContent = `
          [class*="_formFieldContainer_"]:has(${SOURCE_FIELD_SELECTOR}) {
            display: none !important;
          }
        `;
        root.appendChild(style);
      }

      root.querySelectorAll('form').forEach(prepareShopifyFormsSourceField);

      if (!observedRoots.has(root)) {
        root.addEventListener(
          'submit',
          (event) => writeShopifyFormsSource(event.target),
          true
        );
        new MutationObserver(enhanceShopifyForms).observe(root, {
          childList: true,
          subtree: true
        });
        observedRoots.add(root);
      }
    });
  };

  const enhanceAll = () => {
    fillNativeFields(document);
    enhanceShopifyForms();
  };

  document.addEventListener(
    'submit',
    (event) => fillNativeFields(event.target),
    true
  );
  document.addEventListener('shopify:section:load', enhanceAll);

  enhanceAll();
  new MutationObserver(enhanceAll).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  [400, 1000, 2500, 5000, 9000, 15000].forEach((delay) => {
    window.setTimeout(enhanceAll, delay);
  });
})();
